import { withTrailingSlash } from 'ufo'
export default defineNuxtPlugin(async () => {
  await useLanguage().setLanguage()

  addRouteMiddleware(
    'locale',
    async (to, from) => {
      if (withTrailingSlash(to.path) !== withTrailingSlash(from.path)) {
        const { lang, setLanguage } = useLanguage()
        const { init } = useSetup()
        const _lang = to.path.split('/')[1]
        if (_lang !== lang.value) {
          await setLanguage(_lang)
          await init()
        }
      }
    },
    { global: true }
  )
})
